import { Html5Entities } from 'html-entities';
import PropTypes from 'prop-types';
import * as React from 'react';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';

import { EMPTY, LOADING, SUCCESS, SUCCESS_PARTIALLY, WARNING } from '../../global-constants';
import { convertBody, splitAndRemoveEmptyData } from '../../helpers/ui';
import DragDropIcon from '../icon/DragDropIcon';
import Success from '../icon/Success';
import SuccessPartially from '../icon/SuccessPartially';
import Warning from '../icon/Warning';
import LoadingIndicator from '../loading/LoadingIndicator';
import './styles/BodyDragDropImport.scss';
export class BodyDragDropImport extends React.Component {
	constructor(props, context) {
		super(props, context)
		this.state = {
			statusValues: EMPTY,
			selectedFiles: undefined,
			currentFile: undefined,
			progress: 0,
			message: '',
			fileInfos: [],
			dataDragDropExcluded: [],
			dataImported: [],
		};
	}

	onDrop = (files) => {
		const { tree } = this.props;
		if (files.length > 0) {
			this.setState({ selectedFiles: files });

		}
	}
	onDropRejected = (event) => {
		if (event[0].errors[0].code === 'file-invalid-type') {
			this.setState({
				statusValues: WARNING,
			})
		}
	}

	upload = () => {
		let input = document.querySelector('#input-drag-drop');
		input.click()
	}

	componentDidMount() {
		const { selectedFiles } =
			this.state;
		if (!selectedFiles) {
			this.setState({
				statusValues: EMPTY,
			})
		}
	}



	componentDidUpdate() {
		const { switchStateDoneButton, isDisableDoneButton, tree, getDataCSVImported } = this.props;
		const { selectedFiles, dataImported, statusValues } = this.state;
		if (selectedFiles && selectedFiles[0].name && isDisableDoneButton && !dataImported.length && statusValues === EMPTY) {
			const reader = new FileReader();
			reader.readAsText(selectedFiles[0])
			reader.addEventListener(
				'load',
				() => {
					// this will then display a text file
					const cookDataCSV = reader.result.trim().replace(/"/g, '');
					const moreThanOneEnter = splitAndRemoveEmptyData(cookDataCSV);
					const bodyCooked = convertBody(moreThanOneEnter, ',')
					const allDistList = tree.root.value.descendantAccountIds.concat(tree.root.value.id)
					const getDataExcluded = bodyCooked.filter((data) => !allDistList.includes(data))
					const getDataIncluded = bodyCooked.filter((data) => allDistList.includes(data))
					this.setState({
						dataImported: bodyCooked,
						dataDragDropExcluded: getDataExcluded,
					})
					// pass data to parent Component ActionsMenu
					getDataCSVImported(getDataIncluded)
					if (getDataExcluded.length > 0) {
						switchStateDoneButton(false)
						this.setState({
							statusValues: SUCCESS_PARTIALLY,
						})
					} else {
						switchStateDoneButton(false)
						this.setState({
							statusValues: SUCCESS,
						})
					}
				},
				false,
			);


		}
	}


	render() {
		const { i18n } = this.props;
		const { selectedFiles, statusValues, dataDragDropExcluded, progress, message, fileInfos, errorType } = this.state;
		const renderExcludedSuccessPartiallyData = () => {
			if (!dataDragDropExcluded.length) return '';
			const result = dataDragDropExcluded.map((value, idx) => {
				if (dataDragDropExcluded.length === 1 || idx === dataDragDropExcluded.length - 1) {
					return <span key={value}>{value}</span>
				} else {
					return <span key={value}>{`${value}, `}</span>
				}
			})
			return result
		}

		const getClipboardPasteToExcel = () => {
			const { dataDragDropExcluded } = this.state
			const cookData = dataDragDropExcluded.map((data) => `"${data}"`)
			const formatDataForExcel = cookData.join('\n');
			navigator.clipboard.writeText(formatDataForExcel)
		}

		const renderContent = () => {
			if (statusValues === EMPTY) {
				return <Dropzone
					onDrop={this.onDrop}
					onDropRejected={this.onDropRejected}
					multiple={false}
					noClick={true}
					accept={{
						'text/*': [],
						'application/vnd.ms-excel': [],
					}}
				>
					{({ getRootProps, getInputProps }) => (
						<div {...getRootProps({ className: 'dropzone' })} className='empty wrapper'>
							<input {...getInputProps()} id='input-drag-drop' />
							<DragDropIcon />
							<p>{i18n.t('DRAG_DROP_FILE')}</p>
							<p>{i18n.t('OR').toUpperCase()}</p>
							<button
								type='button'
								onClick={this.upload}
							>{i18n.t('BROWSE_FILES')}</button>
							<p className='warning-text'>{i18n.t('WARNING_TEXT_DRAG_DROP')}</p>
						</div>
					)}
				</Dropzone>
			}
			if (statusValues === WARNING) {
				return <div className='warning wrapper'>
					<Warning />
					<b>{i18n.t('NOT_VALID')}</b>
					<p className='file-name'>{i18n.t('MUST_CSV_FILE')}</p>
				</div>
			}
			if (statusValues === LOADING) {
				return <div className='loading wrapper'>
					<LoadingIndicator />
					<b>{i18n.t('UPLOADING_FILE')}...{progress}%</b>
					<p className='file-name'>{selectedFiles[0].name}</p>
				</div>
			}
			if (statusValues === SUCCESS) {
				return <div className='success wrapper'>
					<Success />
					<b>{i18n.t('UPLOADING_SUCCESSFUL')}</b>
					<p className='file-name'>{selectedFiles[0].name}</p>
				</div>
			}
			if (statusValues === SUCCESS_PARTIALLY) {
				return <div className='success-partially wrapper'>
					<SuccessPartially />
					<b>{i18n.t('UPLOADING_SUCCESS_PARTIALLY')}</b>
					<p className='file-name'>{i18n.t('ID_NOT_MATCH')}: {renderExcludedSuccessPartiallyData()}</p>
					<button className="button-copy" onClick={getClipboardPasteToExcel}>{i18n.t('COPY_IDS')}</button>
				</div>
			}
		}

		return (
			<div className='body-drag-drop-container'>
				{renderContent()}
			</div>
		);
	}
}

BodyDragDropImport.propTypes = {
	i18n: PropTypes.shape({}).isRequired,
	tree: PropTypes.shape({}).isRequired,
	allLists: PropTypes.array.isRequired,
	isDisableDoneButton: PropTypes.bool.isRequired,
	switchStateDoneButton: PropTypes.func.isRequired,
	addRemoveItem: PropTypes.func.isRequired,
	checkForEmptyList: PropTypes.func.isRequired,
	getDataCSVImported: PropTypes.func.isRequired,
};

BodyDragDropImport.defaultPropTypes = {
	closeButtonClass: '',
}

export default withTranslation()(BodyDragDropImport);
